import React, { FC, memo } from 'react'
import { LightGallery } from '@ucheba/ui/components/LightGallery/desktop'

import { IGalleryComponentProps } from '../../types'
import { useMediaList } from '../../bll/useMediaList'
import {
  Photos,
  PhotosItem,
  ShowAllButton,
  IconExpandStyled,
  GridContainer,
} from './styles'

const GalleryComponent: FC<IGalleryComponentProps> = ({ mediaList = [] }) => {
  const { list, gridTemplateAreas, isShowMore } = useMediaList(mediaList)

  return (
    <GridContainer>
      <Photos
        as={LightGallery}
        gridTemplateAreas={gridTemplateAreas}
        settings={{
          autoplayFirstVideo: false,
        }}
      >
        {list.map((item, index) => (
          <PhotosItem
            gridArea={`A${index + 1}`}
            id={`A${index + 1}`}
            key={item.src}
            mediaType={item.mediaType}
            {...item}
          />
        ))}
      </Photos>

      {isShowMore && (
        <ShowAllButton
          type='button'
          color='white'
          size='small'
          EndIcon={<IconExpandStyled />}
          onClick={() => {
            document?.getElementById('A1')?.click()
          }}
        >
          Показать все
        </ShowAllButton>
      )}
    </GridContainer>
  )
}

export default memo(GalleryComponent)
